import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Delete.IRequest;
type Response = Api.Core.ProductRefundDocument.Delete.IResponse;
type Headers = Api.Core.ProductRefundDocument.Delete.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/:productId/:documentId';
export default async function productRefundDocumentDeleteApi(params: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
